import { useEffect } from 'react';
import useAppDispatch from 'hooks/useAppDispatch';
import { incrementUnacknowledgedMissedCallCount, incrementUnlistenedVoicemailCount, invalidateCallLogEntities } from 'components/Voice/Actions';
import { VOICE_CHANNEL_NAME } from './voiceConstants';

enum Actions {
  IncrementVoicemail = 'increment_voicemail_badge',
  IncrementUnacknowledgedMissedCallCount = 'increment_unacknowledged_missed_call_count',
}

interface ChannelMessage {
  action: Actions,
}

const useVoiceBroadcastChannel = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!('BroadcastChannel' in window)) return undefined;

    const broadcastChannel = new BroadcastChannel(VOICE_CHANNEL_NAME);
    broadcastChannel.addEventListener('message', ({ data: { action } }: MessageEvent<ChannelMessage>) => {
      switch (action) {
        case Actions.IncrementVoicemail:
          dispatch(incrementUnlistenedVoicemailCount());
          dispatch(invalidateCallLogEntities());
          break;
        case Actions.IncrementUnacknowledgedMissedCallCount:
          dispatch(incrementUnacknowledgedMissedCallCount());
          dispatch(invalidateCallLogEntities());
          break;
        default:
          throw new Error('Unidentified action type');
          break;
      }
    });

    return () => broadcastChannel.close();
  }, [dispatch]);
};

export default useVoiceBroadcastChannel;
